import { motion } from 'framer-motion';
import { alpha } from '@mui/material';

const MotionSvg = motion.svg;
const MotionCircle = motion.circle;

interface AnimatedDigitalRingProps {
  isMobile: boolean;
  primaryColor: string;
  delay?: number; // delayを追加
}

export const AnimatedDigitalRing = ({ isMobile, primaryColor, delay = 0.5 }: AnimatedDigitalRingProps) => {
  const desktopWidth = 440;
  const desktopHeight = 280;
  const mobileWidth = 280;
  const mobileHeight = 180;

  const ringWidth = isMobile ? mobileWidth : desktopWidth;
  const ringHeight = isMobile ? mobileHeight : desktopHeight;

  // アニメーション設定
  const ringDrawVariant = {
    hidden: { 
        pathLength: 0, 
        rotate: -150, 
        opacity: 0 
    },
    visible: { 
        pathLength: 1, 
        rotate: 0,
        opacity: 1,
        transition: { 
            pathLength: { duration: 1.8, delay, ease: [0.22, 1, 0.36, 1] }, // delayを反映
            rotate: { duration: 2.0, delay, ease: "easeOut" }, // delayを反映
            opacity: { duration: 0.5, delay } // delayを反映
        } 
    }
  };

  return (
    <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 0,
      pointerEvents: 'none',
      width: `${ringWidth}px`,
      height: `${ringHeight}px`,
    }}>
      <MotionSvg
        width="100%"
        height="100%"
        viewBox={`0 0 ${ringWidth} ${ringHeight}`}
        fill="none"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.8 }}
      >
        <MotionCircle
          cx={ringWidth / 2}
          cy={ringHeight / 2}
          r={(Math.min(ringWidth, ringHeight) / 2) - 2}
          stroke={primaryColor}
          strokeWidth="1.5"
          strokeOpacity={0.3}
          strokeLinecap="round"
          variants={ringDrawVariant}
          style={{
            transformOrigin: 'center',
            scaleX: ringWidth / ringHeight,
          }}
          strokeDasharray="180 1000" 
        />
      </MotionSvg>

      {/* 内側の光の溜まり */}
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        whileInView={{ opacity: 0.5, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.5, delay: 1.0 + delay }}
        style={{
          width: isMobile ? '160px' : '280px',
          height: isMobile ? '100px' : '160px',
          background: `radial-gradient(circle, ${alpha(primaryColor, 0.4)} 0%, transparent 70%)`,
          filter: 'blur(20px)',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: -1
        }}
      />
    </div>
  );
};